import { isWithinInterval } from 'date-fns';

export const useIsLiveStatus = ({
  startTime,
  endTime,
  hasAccepted,
}: {
  startTime: Date;
  endTime: Date;
  hasAccepted: boolean;
}) => {
  const currentTime = new Date();
  const isLive = isWithinInterval(currentTime, { start: startTime, end: endTime });

  return hasAccepted && isLive;
};
